import { Component, OnInit } from '@angular/core';
import { UserUtilService } from 'src/app/core/services/common/user-util.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  CurentDate=new Date()
  isLoggedIn: boolean = false;
  userName: string | null = '';
  constructor(public userUtilsService:UserUtilService, private router: Router, private authService: AuthService) { }
  isPopupVisible: boolean = false;
  ngOnInit(): void {

    this.authService.isLoggedIn$.subscribe((loggedIn) => {
      this.isLoggedIn = loggedIn;
      if (loggedIn) {
        const user = this.authService.getUserInfo();
        this.userName = user ? `${user.FirstName} ${user.LastName}` : '';
      } else {
        this.userName = '';
      }
    });
  }

  checkLoginStatus() {
    const user = this.authService.getUserInfo();
    if (user) {
      this.isLoggedIn = true;
      this.userName = `${user.FirstName} ${user.LastName}`;
    }
  }
  logout() {
    this.authService.clearUserInfo();
    this.isLoggedIn = false;

    this.router.navigateByUrl(`/`);

  }
  showPopup() {
    this.isPopupVisible = true;
  }

  closePopup() {
    this.isPopupVisible = false;
  }

}
